import React, { Component } from 'react';
import appConfig from '../../config/client';

class AdminPage extends Component {
  state = {

  };

  async componentDidMount() {

  }


  render() {
    return (<div/>
    );
  }
}

export default AdminPage;



// WEBPACK FOOTER //
// ./src/containers/pages/AdminPage.js